import { createApi } from '@reduxjs/toolkit/query/react';

import { INTERNAL_ERROR_STATUS_CODE } from '@/constants';
import { normalizeContent } from '@/normalize';
import { getContentUrl, request } from '@/utils';

export const contentApi = createApi({
  reducerPath: 'content',
  endpoints: (builder) => ({
    getContent: builder.query({
      queryFn: async ({ locale, pathname }) => {
        try {
          const url = getContentUrl({ locale, url: pathname });
          const response = await request(url, false);
          const normalizedData = normalizeContent(response?.data);

          return { data: normalizedData };
        } catch (error) {
          return {
            error: {
              status: error?.response?.status || INTERNAL_ERROR_STATUS_CODE,
            },
          };
        }
      },
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetContentQuery,
  util: { getRunningQueriesThunk: getRunningOperationPromisesContent },
} = contentApi;

// export endpoints for use in SSR
export const { getContent } = contentApi.endpoints;
